(function () {
    'use strict';

    angular
        .module('jotApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('tab-domains', {
                parent: 'entity',
                url: '/tab-domains?page&sort&search',
                data: {
                    authorities: ['ROLE_TECH'],
                    pageTitle: 'jotApp.tabDomains.home.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-domains/tab-domains.html',
                        controller: 'TabDomainsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    page: {
                        value: '1',
                        squash: true
                    },
                    sort: {
                        value: 'id,asc',
                        squash: true
                    },
                    search: {
                        value: '',
                        squash: true
                    },
                    predicates: {},
                    itemsPerPageChosen: null
                },
                resolve: {
                    pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                        return {
                            page: PaginationUtil.parsePage($stateParams.page),
                            sort: $stateParams.sort,
                            predicates: $stateParams.predicates,
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabDomains');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
            .state('tab-domains-detail', {
                parent: 'tab-domains',
                url: '/tab-domains/{id}',
                data: {
                    authorities: ['ROLE_TECH'],
                    pageTitle: 'jotApp.tabDomains.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-domains/tab-domains-detail.html',
                        controller: 'TabDomainsDetailController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabDomains');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabDomains', function ($stateParams, TabDomains) {
                        return TabDomains.get({id: $stateParams.id});
                    }]
                }
            })
            .state('tab-domains-new', {
                parent: 'tab-domains',
                url: '/new',
                data: {
                    authorities: ['ROLE_TECH'],
                    pageTitle: 'jotApp.tabDomains.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-domains/tab-domains-dialog.html',
                        controller: 'TabDomainsDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabDomains');
                        return $translate.refresh();
                    }],
                    entity: function () {
                        return {
                            domainName: null,
                            domainDescription: null,
                            domainCaCrt: null,
                            domainClientCrt: null,
                            domainClientKey: null,
                            isActive: false,
                            isVisibile: false,
                            id: null
                        };
                    }
                }
            })
            .state('tab-domains-edit', {
                parent: 'tab-domains',
                url: '/{id}/edit',
                data: {
                    authorities: ['ROLE_TECH'],
                    pageTitle: 'jotApp.tabDomains.detail.title'
                },
                views: {
                    'content@main': {
                        templateUrl: 'app/entities/tab-domains/tab-domains-dialog.html',
                        controller: 'TabDomainsDialogController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('tabDomains');
                        return $translate.refresh();
                    }],
                    entity: ['$stateParams', 'TabDomains', function ($stateParams, TabDomains) {
                        return TabDomains.get({id: $stateParams.id});
                    }]
                }
            })
            .state('tab-domains.delete', {
                parent: 'tab-domains',
                url: '/{id}/delete',
                data: {
                    authorities: ['ROLE_TECH']
                },
                onEnter: ['$stateParams', '$state', '$uibModal', function ($stateParams, $state, $uibModal) {
                    $uibModal.open({
                        templateUrl: 'app/entities/tab-domains/tab-domains-delete-dialog.html',
                        controller: 'TabDomainsDeleteController',
                        controllerAs: 'vm',
                        size: 'md',
                        resolve: {
                            entity: ['TabDomains', function (TabDomains) {
                                return TabDomains.get({id: $stateParams.id});
                            }]
                        }
                    }).result.then(function () {
                        $state.go('tab-domains', null, {reload: true});
                    }, function () {
                        $state.go('^');
                    });
                }]
            });
    }

})();
